import Drawer from "../../../../drawer/Drawer";
import ManageFaq from "../ManageFaq";

const ManageFaqDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={
        data?._id ? (
          <span className="tracking-tighter uppercase font-bold">
            Update FAQ
          </span>
        ) : (
          <span className="tracking-tighter uppercase font-bold">Add FAQ</span>
        )
      }
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageFaq getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageFaqDrawer;
